import React, { useState } from 'react';
// CSS Styles
import './Tabs.css';
import Layout from '../../Layout'
import Invited from './joined';
import Joined from './Invited';
import { BsInfoCircle, BsPersonUp, BsPersonAdd, BsPuzzle } from 'react-icons/bs';
import {MyTaskData} from '../../components/Datas';

const Index = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabWorkLog, setActiveTabWorkLog] = useState(0);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    const handleTabClickWorkLog = (index) => {
        setActiveTabWorkLog(index);
    };

    const tasksInProgress = [
        { id: 1, name: "Task 1", status: "In Progress" },
        { id: 2, name: "Task 2", status: "In Progress" },
    ];

    const scheduledTasks = [
        // { id: 3, name: "Task 3", status: "Scheduled" },
        // { id: 4, name: "Task 4", status: "Scheduled" },
    ];

    return (
        <Layout>
            <div className="tabs-container">
                <div className="tabs">
                    <div
                        className={`tab ${activeTab === 0 ? 'active' : ''} flex items-center gap-1`}
                        onClick={() => handleTabClick(0)}
                    >
                        <BsPersonAdd className='text-teal-500' size={19} />
                        Joined
                    </div>
                    <div
                        className={`tab ${activeTab === 1 ? 'active' : ''} flex items-center gap-1`}
                        onClick={() => handleTabClick(1)}
                    >
                        <BsPersonUp className='text-teal-500' size={19} />
                        Invited
                    </div>
                </div>
                <div className="tab-content">
                    {activeTab === 0 && (
                        <div className="container">
                            <div className="w-full grid xl:grid-cols-6 grid-cols-1 gap-6">
                                <div className="xl:col-span-6  w-full">
                                    {/* Task */}
                                    <div className="mt-6 bg-white rounded-xl border-[1px] border-border p-5">
                                        {/* title */}
                                        <div className="flex gap-4 items-center">
                                        </div>
                                            <Invited
                                                data={MyTaskData.slice(0, 5)}
                                                action={false}
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === 1 && (
                        <div className="container">
                            <div className="w-full grid xl:grid-cols-6 grid-cols-1 gap-6">
                                <div className="xl:col-span-6  w-full">
                                    {/* Task */}
                                    <div className="mt-6 bg-white rounded-xl border-[1px] border-border p-5">
                                        {/* title */}
                                        <div className="flex gap-4 items-center">
                                        </div>
                                            <Joined
                                                data={MyTaskData.slice(0, 5)}
                                                action={false}
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default Index;


